__webpack_require__.p = "/wp-content/plugins/tariff-comparator/tariff-comparator-app/build/";